import { deleteFormacaoAcademica } from 'pages/Alunos/VagasCurriculo/FormacaoAcademica/requests';
import { toast } from 'react-toastify';

import * as S from './styles';

import Trash from 'assets/icons/trash.svg';
import Pen from 'assets/icons/pen.svg';

export const CardFormacaoAcademica = ({
  id,
  instituicao,
  descricao,
  data_inicio,
  data_fim,
  formacaoAcademica,
  setFormacaoAcademica,
  setPreFormacaoAcademica,
}) => {
  const checkIfAlreadyEditing = () => {
    const formacaoIndex = formacaoAcademica.findIndex((item) => item.editing);
    return formacaoIndex > -1 ? true : false;
  };

  const deleteItem = async (id) => {
    if (checkIfAlreadyEditing()) {
      alert('Termine a edição antes de deletar.');
    } else {
      const formacaoIndex = formacaoAcademica.findIndex((item) => item.id === id);
      const response = await deleteFormacaoAcademica(formacaoAcademica[formacaoIndex]);

      if (response.status === 200) {
        const data = await response.json();
        setFormacaoAcademica(formacaoAcademica.filter((item) => item.id !== data.id));
        toast.success('Formação acadêmica deletada com sucesso!');
      } else {
        toast.error('Erro ao deletar formação acadêmica.');
      }
    }
  };

  const editItem = (id) => {
    if (checkIfAlreadyEditing()) {
      alert('Termine a edição antes de editar.');
    } else {
      const formacaoIndex = formacaoAcademica.findIndex((item) => item.id === id);
      const newFormacaoAcademica = [...formacaoAcademica];

      newFormacaoAcademica[formacaoIndex] = {
        ...newFormacaoAcademica[formacaoIndex],
        editing: true,
      };

      setFormacaoAcademica(newFormacaoAcademica);
      setPreFormacaoAcademica(newFormacaoAcademica[formacaoIndex]);
    }
  };

  return (
    <S.Card>
      <S.Text>
        <S.Title>{`${instituicao} - ${descricao}`}</S.Title>
        {data_inicio && <S.Description>{`Período: ${data_inicio} à ${data_fim || 'atualmente'}`}</S.Description>}
      </S.Text>

      <S.ActionButtons>
        <S.ActionButtonDelete type="button" onClick={() => deleteItem(id)}>
          <img src={Trash} alt="Ícone de lixeira" />
        </S.ActionButtonDelete>

        <S.ActionButtonEdit type="button" onClick={() => editItem(id)}>
          <img src={Pen} alt="Ícone de lápis" />
        </S.ActionButtonEdit>
      </S.ActionButtons>
    </S.Card>
  );
};
